// extracted by mini-css-extract-plugin
export default {"icons":"icon_icons__Q9qru"};